import { SpineAdapter } from "../SpineAdapter";
import { SpineWasmVirturalMesh } from "../mesh/SpineWasmVirturalMesh";
import { SpineNormalRenderBase } from "./SpineNormalRenderBase";
export class SpineWasmRender extends SpineNormalRenderBase {
    constructor(templet) {
        super();
        this.vmeshs = [];
        this.nextBatchIndex = 0;
        this.templet = templet;
    }
    createMesh(material) {
        return new SpineWasmVirturalMesh(material);
    }
    draw(skeleton, renderNode, slotRangeStart, slotRangeEnd) {
        this.nextBatchIndex = 0;
        SpineAdapter.drawSkeleton((vbLen, ibLen, texturePath, blendMode) => {
            let mat = renderNode.templet.getMaterial(this.templet.getTexture(texturePath), blendMode.value);
            let mesh = this.nextBatch(mat, renderNode);
            mesh.drawByData(SpineAdapter._vbArray, vbLen, SpineAdapter._ibArray, ibLen);
        }, skeleton, true, slotRangeStart, slotRangeEnd);
    }
}
